import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { id } = payload || {}
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_CUSTOMER_DELETE, {
      pathParams: {
        customerId: id,
      },
    })
  },

  method: 'DELETE',

  parse(raw = {}) {
    if (!raw.success) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to delete customer',
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Client supprimé avec succès',
      data: raw.data,
    }
  },
}
